import { type RemoveHookResponse, mutationRemove } from '../../hooks'
import { useTantalimMutation } from '../../mutation'
import { useGameCache } from '../cache'
import { type GameParticipantRemoveInput, toResponseError, type ResponseSuccess } from '@terros/common'

export function useRemoveGameParticipant(): RemoveHookResponse<GameParticipantRemoveInput> {
  const cache = useGameCache()

  const mutation = useTantalimMutation<GameParticipantRemoveInput, ResponseSuccess>({
    url: '/game/participant/remove',
  })

  async function remove(props: GameParticipantRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(props)
      cache.removeParticipant(props.gameId, props.participantId)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
